import styled from "styled-components";

export const ContractFontTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 10px;
`;

export const ContractFontText = styled.div`
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 10px;
`;
